import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import useApi from "../../../utils/custom-hooks/api-hooks/useApi";
import {IEstimate} from "../../../utils/interfaces/Estimate/IEstimate";
import {useApp} from "../../../utils/global-contexts/AppContext";


const useApiUpdateEstimate = (): UseMutationResult<IEstimate, AxiosError, {
    id: number | undefined;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {userId} = useApp()

    const {putEncoded, put} = useApi()

    async function doMutation(pk: number | undefined,
                              data: any): Promise<IEstimate> {
        try {
            const response = await put(`/estimates/${pk}`, data);
            return response.data.data as IEstimate;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IEstimate, AxiosError, {
        id: number | undefined;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doMutation(id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetUserEstimates', userId]});
        },
    });
};


export default useApiUpdateEstimate;
